
// import React from "react";
// import { AppBar, Toolbar, Button, Typography } from "@mui/material";
// import { useNavigate, useLocation } from "react-router-dom";

// // Import icons
// import HomeIcon from "@mui/icons-material/Home";
// import InfoIcon from "@mui/icons-material/Info";
// import SettingsIcon from "@mui/icons-material/Settings";
// import HistoryIcon from "@mui/icons-material/History";
// import ReportIcon from "@mui/icons-material/Report";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import LogoutIcon from "@mui/icons-material/Logout";

// const Navbar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const currentUser = sessionStorage.getItem("currentUser");

//   const handleLogout = () => {
//     if (currentUser) {
//       sessionStorage.removeItem(`token_${currentUser}`);
//       sessionStorage.removeItem("currentUser");
//       navigate("/");
//     }
//   };

  // const forceNavigate = (path) => {
  //   if (location.pathname === path) {
  //     // Force reload the page if it's the same route
  //     navigate("/refresh", { replace: true }); // Optional dummy route
  //     setTimeout(() => navigate(path), 0);
  //   } else {
  //     navigate(path);
  //   }
  // };

//   const showNavButtons = currentUser && location.pathname !== "/";

//   return (
//     <AppBar position="static" sx={{ backgroundColor: "#1976d2" }}>
//       <Toolbar>
//         {showNavButtons && (
//           <>
//             <Typography variant="h6" sx={{ flexGrow: 1 }}>
//               <Button color="inherit" onClick={() => forceNavigate("/dashboard2")} startIcon={<HomeIcon />}>
//                 RAKSHAK-G2
//               </Button>
//             </Typography>

//             <Button color="inherit" onClick={() => forceNavigate("/dashboard")} startIcon={<HomeIcon />}>
//               Home
//             </Button>

//             <Button color="inherit" onClick={() => forceNavigate("/HistoryPage")} startIcon={<HistoryIcon />}>
//               Track History
//             </Button>

//             <Button color="inherit" onClick={() => forceNavigate("/Report")} startIcon={<ReportIcon />}>
//               Report
//             </Button>

//             <Button color="inherit" onClick={() => forceNavigate("/profile")} startIcon={<AccountCircleIcon />}>
//               Profile
//             </Button>

//             <Button color="inherit" onClick={() => forceNavigate("/settings")} startIcon={<SettingsIcon />}>
//               Settings
//             </Button>

//             <Button color="inherit" onClick={() => forceNavigate("/about")} startIcon={<InfoIcon />}>
//               About
//             </Button>

//             <Button color="inherit" onClick={handleLogout} startIcon={<LogoutIcon />}>
//               Logout ({currentUser})
//             </Button>
//           </>
//         )}
//       </Toolbar>
//     </AppBar>
//   );
// };

// export default Navbar;
//amjansir.................................................
// import React from "react";
// import { AppBar, Toolbar, Button, Typography } from "@mui/material";
// import { Link, useNavigate, useLocation } from "react-router-dom";

// // Import icons
// import HomeIcon from "@mui/icons-material/Home";
// import InfoIcon from "@mui/icons-material/Info";
// import SettingsIcon from "@mui/icons-material/Settings";
// import HistoryIcon from "@mui/icons-material/History";
// import ReportIcon from "@mui/icons-material/Report";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import LogoutIcon from "@mui/icons-material/Logout";
// // import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
// import { Menu, MenuItem } from "@mui/material";
// import { useState } from "react";

// import axios from "axios";
// const Navbar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const currentUser = sessionStorage.getItem("currentUser");

//  // const handleLogout = () => {
//  //   if (currentUser) {
//  //     sessionStorage.removeItem(`token_${currentUser}`);
// //      sessionStorage.removeItem("currentUser");
//  //     navigate("/");
//  //   }
//  // };

//  // State to manage Settings menu
// const [anchorEl, setAnchorEl] = useState(null);
// const open = Boolean(anchorEl);

// const handleSettingsClick = (event) => {
//   setAnchorEl(event.currentTarget);
// };

// const handleSettingsClose = () => {
//   setAnchorEl(null);
// };



//  const handleLogout = async () => {
//   const currentUser = sessionStorage.getItem("currentUser");
//   const token = sessionStorage.getItem(`token_${currentUser}`);
//   //const navigate = useNavigate(); // if not already in component scope

//   try {
//     if (currentUser) {
//       console.log("logout section")
//       // Call backend logout to destroy session and clear userSessions map
//       await axios.post("http://localhost:5000/api/logout",{},{
//        // withCredentials: true, // Send session cookie
        
//           headers: { authorization: `Bearer ${token}` }
//         });
//         console.log("logout section2")

//       // Clear frontend session storage
//       sessionStorage.removeItem(`token_${currentUser}`);
//       sessionStorage.removeItem("currentUser");

//       // Redirect to login
//       navigate("/");
//     }
//   } catch (err) {
//     console.error("Logout failed:", err);
//     alert("Logout failed. Please try again.");
//   }
// };


//   const showNavButtons = currentUser && location.pathname !== "/";

//   return (
//     <AppBar position="static" sx={{ backgroundColor: "#1976d2" }}>
//       <Toolbar>
//         {showNavButtons && (
//           <>
//             <Typography variant="h6" sx={{ flexGrow: 1 }}>
         
//               <Button color="inherit" component={Link} to="/dashboard2" startIcon={<HomeIcon />}>
//               RAKSHAK-G2
//             </Button>
//             </Typography>

//             <Button color="inherit" component={Link} to="/dashboard" startIcon={<HomeIcon />}>
//               Home
//             </Button>
           
           
//             <Button color="inherit" component={Link} to="/HistoryPage" startIcon={<HistoryIcon />}>
//               Track History
//             </Button>
//             <Button color="inherit" component={Link} to="/Report" startIcon={<ReportIcon />}>
//               Report
//             </Button>
//             <Button color="inherit" component={Link} to="/profile" startIcon={<AccountCircleIcon />}>
//               Profile
//             </Button>
//            <Button
//   color="inherit"
//   onClick={handleSettingsClick}
//   startIcon={<SettingsIcon />}
// >
//   Settings
// </Button>
// <Menu
//   anchorEl={anchorEl}
//   open={open}
//   onClose={handleSettingsClose}
// >
//   <MenuItem component={Link} to="/settings" onClick={handleSettingsClose}>
//     Settings
//   </MenuItem>
//   <MenuItem component={Link} to="/admin" onClick={handleSettingsClose}>
//     Admin Console
//   </MenuItem>
// </Menu>

//             <Button color="inherit" component={Link} to="/about" startIcon={<InfoIcon />}>
//               About
//             </Button>
//             <Button color="inherit" onClick={handleLogout} startIcon={<LogoutIcon />}>
//               Logout ({currentUser})
//             </Button>
//           </>
//         )}
//       </Toolbar>
//     </AppBar>
//   );
// };

// export default Navbar;


import React, { useState } from "react";
import { AppBar, Toolbar, Button, Typography, Menu, MenuItem } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import SettingsIcon from "@mui/icons-material/Settings";
import HistoryIcon from "@mui/icons-material/History";
import ReportIcon from "@mui/icons-material/Report";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";

import axios from "./AxiosInstance";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentUser = sessionStorage.getItem("currentUser");
  const userType = sessionStorage.getItem("userType");
  console.log("userType",userType);
  // State for settings dropdown menu
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleSettingsClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSettingsClose = () => {
    setAnchorEl(null);
  };

  // Force navigation even on same path
  const forceNavigate = (path) => {
    if (location.pathname === path) {
      navigate("/refresh", { replace: true }); // Optional dummy route
      setTimeout(() => navigate(path), 0);
    } else {
      navigate(path);
    }
  };

  // Logout logic
  const handleLogout = async () => {
    const token = sessionStorage.getItem(`token_${currentUser}`);

    try {
      if (currentUser) {
        await axios.post(
          "/api/logout",
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        sessionStorage.removeItem(`token_${currentUser}`);
        sessionStorage.removeItem("currentUser");
        navigate("/");
      }
    } catch (err) {
      console.error("Logout failed:", err);
      alert("Logout failed. Please try again.");
    }
  };

  const showNavButtons = currentUser && location.pathname !== "/";

  return (
    <AppBar position="static" sx={{ backgroundColor: "#1976d2" }}>
      <Toolbar>
        {showNavButtons && (
          <>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              <Button
                color="inherit"
                onClick={() => forceNavigate("/dashboard2")}
                startIcon={<HomeIcon />}
              >
                RAKSHAK-G2
              </Button>
            </Typography>

            <Button
              color="inherit"
              onClick={() => forceNavigate("/dashboard")}
              startIcon={<HomeIcon />}
            >
              Home
            </Button>

            <Button
              color="inherit"
              onClick={() => forceNavigate("/HistoryPage")}
              startIcon={<HistoryIcon />}
            >
              Track History
            </Button>

            <Button
              color="inherit"
              onClick={() => forceNavigate("/Report")}
              startIcon={<ReportIcon />}
            >
              Report
            </Button>

            <Button
              color="inherit"
              onClick={() => forceNavigate("/profile")}
              startIcon={<AccountCircleIcon />}
            >
              Profile
            </Button>
            
         {userType === "0" && (  <Button
  color="inherit"
  onClick={handleSettingsClick}
  startIcon={<SettingsIcon />}
>
  Settings
</Button>
)}
            {/* <Button
              color="inherit"
              onClick={handleSettingsClick}
              startIcon={<SettingsIcon />}
            >
              Settings
            </Button> */}
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleSettingsClose}
            >
              <MenuItem onClick={() => { handleSettingsClose(); forceNavigate("/settings"); }}>
                Settings
              </MenuItem>
              <MenuItem onClick={() => { handleSettingsClose(); forceNavigate("/admin"); }}>
                Admin Console
              </MenuItem>
            </Menu>

            <Button
              color="inherit"
              onClick={() => forceNavigate("/about")}
              startIcon={<InfoIcon />}
            >
              About
            </Button>

            <Button
              color="inherit"
              onClick={handleLogout}
              startIcon={<LogoutIcon />}
            >
              Logout ({currentUser})
            </Button>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
